export default "__VITE_PUBLIC_ASSET__ff8a8778__"